export default __webpack_public_path__ + "static/media/61b82ea959a495fc.243c4b4417f45b41fa70ef314a3adcd8.svg";